import { createPaymentLink as createPaymentLinkApi } from '@/entities/insurance/api';
import { Env } from '@/shared/config/environment';

const state = {
  invoiceLink: null,
  qrCode: null,
  isLoading: false,
  error: null,
  copySuccess: false,
  percentageAcquiring: 0,
  paymentSystemTitle: '',
  acquiringPaidBy: 'client',
};

const mutations = {
  SET_INVOICE_LINK(state, invoiceLink) {
    state.invoiceLink = invoiceLink;
  },
  SET_QR_CODE(state, qrCode) {
    state.qrCode = qrCode;
  },
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  SET_COPY_SUCCESS(state, copySuccess) {
    state.copySuccess = copySuccess;
  },
  SET_ACQUIRING_INFO(state, { percentageAcquiring, paymentSystemTitle, acquiringPaidBy }) {
    state.percentageAcquiring = percentageAcquiring;
    state.paymentSystemTitle = paymentSystemTitle;
    state.acquiringPaidBy = acquiringPaidBy;
  },
  CLEAR_INVOICE(state) {
    state.invoiceLink = null;
    state.qrCode = null;
    state.isLoading = false;
    state.error = null;
    state.copySuccess = false;
    state.percentageAcquiring = 0;
    state.paymentSystemTitle = '';
    state.acquiringPaidBy = 'client';
  },
};

const actions = {
  async createPaymentLink({ commit, dispatch }, { orderId, amount, providerCode, paidBy, invoiceType, installmentTerm }) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const response = await createPaymentLinkApi({ orderId, amount, providerCode, paidBy, invoiceType, installmentTerm });
      const invoiceLink = response?.data?.invoiceLink ?? null;

      if (!invoiceLink) {
        const emptyLinkMessage = 'Не вдалося сформувати рахунок для цього способу оплати. Спробуйте інший.';
        commit('SET_ERROR', emptyLinkMessage);

        if (Env.features.showNetworkErrorMessages) {
          dispatch('notificationModule/showNotificationErrorMessage', {
            title: 'Спосіб оплати недоступний',
            message: emptyLinkMessage,
          }, { root: true });
        }

        return;
      }

      commit('SET_INVOICE_LINK', invoiceLink);
      commit('SET_QR_CODE', response?.data?.qrCode ?? null);
    } catch (error) {
      const errorMessage = error.response?.data?.message
        || error.response?.data?.error
        || error.message
        || 'Не вдалося створити посилання на оплату';

      commit('SET_ERROR', errorMessage);

      if (Env.features.showNetworkErrorMessages) {
        dispatch('notificationModule/showNotificationErrorMessage', {
          error,
          title: 'Не вдалося створити посилання на оплату',
          message: errorMessage,
        }, { root: true });
      }
    } finally {
      commit('SET_LOADING', false);
    }
  },
  setAcquiringInfo({ commit }, providerData) {
    commit('SET_ACQUIRING_INFO', {
      percentageAcquiring: providerData?.percentage_acquiring ?? 0,
      paymentSystemTitle: providerData?.title ?? '',
      acquiringPaidBy: providerData?.paid_by ?? 'client',
    });
  },
  setCopySuccess({ commit }, copySuccess) {
    commit('SET_COPY_SUCCESS', copySuccess);
  },
  clearInvoice({ commit }) {
    commit('CLEAR_INVOICE');
  },
};

const getters = {
  getInvoiceLink: state => state.invoiceLink,
  getQrCode: state => state.qrCode,
  isPaymentLinkLoading: state => state.isLoading,
  getPaymentLinkError: state => state.error,
  isCopySuccess: state => state.copySuccess,
  getPercentageAcquiring: state => state.percentageAcquiring,
  getPaymentSystemTitle: state => state.paymentSystemTitle,
  getAcquiringPaidBy: state => state.acquiringPaidBy,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
